// Location decides the country (and so the currency), not a country saved
// from an earlier visit.
//
// Shopify picks the country from the visitor's IP only on their first visit,
// then keeps it in a cookie for a year. Once per browser session this asks
// Shopify where the visitor is now and, if that differs from the active
// country, switches to it.
//
// A country the shopper chose themselves (the footer selector, or a link with
// ?country=XX) is kept for the rest of the session. If the location lookup
// fails, nothing changes: the site behaves as it did before this script.
(function () {
  var CHECKED = 'bq_geo_checked';
  var MANUAL = 'bq_geo_manual';

  function hasCookie(name) {
    return document.cookie.split('; ').some(function (c) {
      return c.indexOf(name + '=') === 0;
    });
  }

  // Session cookies (no expiry): shared across tabs, cleared with the session.
  function setCookie(name) {
    document.cookie = name + '=1; path=/; SameSite=Lax';
  }

  function markManual() {
    setCookie(MANUAL);
  }

  // A shopper choosing a country in any localization form.
  document.addEventListener('submit', function (e) {
    if (e.target && e.target.matches && e.target.matches('form[action$="/localization"]')) markManual();
  }, true);
  document.addEventListener('input', function (e) {
    if (e.target && e.target.name === 'country_code') markManual();
  }, true);

  if (window.Shopify && Shopify.designMode) return;
  if (new URLSearchParams(location.search).has('country')) markManual();
  if (hasCookie(MANUAL) || hasCookie(CHECKED)) return;

  var current = window.Shopify && Shopify.country;
  if (!current || !window.fetch) return;

  // Mark first, so a failed or slow lookup can never cause a reload loop.
  setCookie(CHECKED);

  var url = '/browsing_context_suggestions.json?country%5Benabled%5D=true';
  fetch(url, { credentials: 'same-origin' })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (data) {
      if (!data || hasCookie(MANUAL)) return;
      var detected = data.detected_values && data.detected_values.country && data.detected_values.country.handle;
      var part = data.suggestions && data.suggestions[0] && data.suggestions[0].parts && data.suggestions[0].parts.country;
      var available = (part && part.options) || {};
      if (!detected || detected === current || !available[detected]) return;

      var form = document.createElement('form');
      form.method = 'post';
      form.action = '/localization';
      form.style.display = 'none';
      var fields = {
        form_type: 'localization',
        utf8: '✓',
        _method: 'put',
        return_to: location.pathname + location.search + location.hash,
        country_code: detected
      };
      Object.keys(fields).forEach(function (k) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = k;
        input.value = fields[k];
        form.appendChild(input);
      });
      document.body.appendChild(form);
      // Native submit: does not fire the submit listener, so it is not
      // recorded as the shopper's own choice.
      HTMLFormElement.prototype.submit.call(form);
    })
    .catch(function () {});
})();
